import { Mail, Twitter, Instagram, Globe } from 'lucide-react'

export function Footer({ onNavigate }: { onNavigate: (view: string) => void }) {
  return (
    <footer className="bg-[#050910] border-t border-white/5 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Logo and Tagline */}
          <div className="col-span-1 md:col-span-2 space-y-4">
            <div className="flex items-center gap-3 cursor-pointer group" onClick={() => onNavigate('home')}>
              <img src="/scoutang-logo.svg" alt="Scouta Logo" className="w-9 h-9 transition-transform group-hover:scale-110" />
              <span className="text-xl font-display font-bold text-white tracking-tight">Scouta</span>
            </div>
            <p className="text-slate-200 text-sm max-w-xs">
              Nigeria’s leading football talent database. Building a data-driven future for scouting and player discovery.
            </p>
            <div className="flex items-center gap-4 pt-4">
              <a href="https://x.com/useScouta" target="_blank" rel="noreferrer" className="text-slate-200 hover:text-green-500 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-slate-200 hover:text-green-500 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-slate-200 hover:text-green-500 transition-colors">
                <Globe className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-white font-semibold text-sm uppercase tracking-widest">Platform</h4>
            <ul className="space-y-2">
              <li><button onClick={() => onNavigate('explore')} className="text-slate-200 hover:text-white text-sm">Explore Talent</button></li>
              <li><button onClick={() => onNavigate('blog')} className="text-slate-200 hover:text-white text-sm">Blog</button></li>
              <li><button onClick={() => onNavigate('how-it-works')} className="text-slate-200 hover:text-white text-sm">How it Works</button></li>
              <li><button onClick={() => onNavigate('pricing')} className="text-slate-200 hover:text-white text-sm">Pricing</button></li>
              <li><button onClick={() => onNavigate('about')} className="text-slate-200 hover:text-white text-sm">About Us</button></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="text-white font-semibold text-sm uppercase tracking-widest">Support</h4>
            <ul className="space-y-2">
              <li><button onClick={() => onNavigate('support')} className="text-slate-200 hover:text-white text-sm text-[10px] sm:text-xs">FAQs</button></li>
              <li>
                <a href="mailto:scoutasupport@gmail.com" className="flex items-center gap-2 text-slate-200 hover:text-white text-sm">
                  <Mail className="w-4 h-4" />
                  scoutasupport@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-300 uppercase tracking-widest">
          <p>© {new Date().getFullYear()} Scouta. Built in Nigeria for the World.</p>
          <div className="flex gap-6">
            <button onClick={() => onNavigate('privacy')} className="hover:text-white">Privacy Policy</button>
            <button onClick={() => onNavigate('terms')} className="hover:text-white">Terms of Service</button>
          </div>
        </div>
      </div>
    </footer>
  )
}
